export const adminMenu = [
	{
		"id": 1,
		"icon": "usd",
		"label": "Historial Pagos",
		"to": "/historialpago"
	},
	{
		"id": 2,
		"icon": "usd",
		"label": "Registro Gasto",
		"to": "/gastocorriente"
	},
	
	{
		"id": 3,
		"icon": "users",
		"label": "Corte Caja Resumen",
		"to": "/cortecajar"
	},
	/*
	{
		"id": 4,
		"icon": "users",
		"label": "Alumnos Siguiente Ciclo",
		"to": "/alumnossiguienteciclo"
	},
	*/

	{
		"id": 5,
		"icon": "credit-card",
		"label": "Colegiaturas",
		"to": "/colegiaturas"
	},
	{
		"id": 6,
		"icon": "cart-plus",
		"label": "Servicios",
		"to": "/servicios"
	},
	
	{
		"id": 8,
		"icon": "check-square-o",
		"label": "Reglas Establecidas",
		"to": "/reglasestablecidas"
	},
	{
		"id": 10,
		"icon": "handshake-o",
		"label": "Becas",
		"to": "/becas"
	}
]
export const universityMenu = [
	{
		"id": 2,
		"icon": "plus-circle",
		"label": "Tutor Express",
		"to": "/altaexpress"
	},
	{
		"id": 3,
		"icon": "plus-circle",
		"label": "Alumno Express",
		"to": "/alumnoexpress"
	},
	{
		"id": 4,
		"icon": "user-circle-o",
		"label": "Tutor",
		"to": "/tutor"
	},
	{
		"id": 5,
		"icon": "users",
		"label": "Alumnos",
		"to": "/alumno"
	},
	{
		"id": 6,
		"icon": "usd",
		"label": "Alumnos En Pagos",
		"to": "/alumnoenpagos"
	}
];


/*
 * ,
	{
		"id": 7,
		"icon": "usd",
		"label": "Carrito",
		"to": "/carrito"
	}
 ,
	{
		"id": 8,
		"icon": "line-chart",
		"label": "Reporte General",
		"to": "/leave"
		
	},
{

	"id": 9,
		"icon": "gear",
			"label": "Perfil",
				"to": "/setting"

}
 
 */

/*
 {
		"id": 1,
		"icon": "dashboard",
		"label": "Informe Ejecutivo",
		"to": "/"
	},
 

,
	{
		"id": 7,
		"icon": "black-tie",
		"label": "Profesores",
		"to": "/professors"
	},
	{
		"id": 8,
		"icon": "graduation-cap",
		"label": "Cursos",
		"to": "/courses"
	},
	{
		"id": 9,
		"icon": "phone",
		"label": "Contacto",
		"to": "/departments"
	},
	{
		"id": 10,
		"icon": "file-text-o",
		"label": "Inscripciones",
		"to": "/holiday"
	},

	{
		"id": 11,
		"label": "Extra",
	},
	{
		"id": 12,
		"icon": "calendar",
		"label": "Calendario",
		"to": "/events"
	},
	{
		"id": 13,
		"icon": "address-book",
		"label": "Contacto",
		"to": "/contact"
	},
	{
		"id": 14,
		"icon": "folder",
		"label": "Archivos",
		"to": "/fileManager"
	},
	{
		"id": 15,
		"icon": "camera-retro",
		"label": "Gallery",
		"to": "/gallery"
	},
 */